<svg xmlns="http://www.w3.org/2000/svg"
     class="board"
     [attr.viewBox]="viewBoxString()"
     preserveAspectRatio="xMidYMid meet">
    @for (line of board; track $index; let y = $index) {
        <g>
            @for (c of line; track $index; let x = $index) {
                <g id="click-{{ x }}-{{ y }}"
                   (click)="onClick(x, y)">
                    <rect id="space-{{ x }}-{{ y }}"
                          [attr.x]="SPACE_SIZE * x"
                          [attr.y]="SPACE_SIZE * y"
                          [attr.width]="SPACE_SIZE"
                          [attr.height]="SPACE_SIZE"
                          [ngClass]="getRectClasses(x, y)"
                          class="base"/>
                    @if (board[y][x] !== EMPTY) {
                        <circle id="piece-{{ x }}-{{ y }}"
                                [attr.r]="(SPACE_SIZE / 2) - STROKE_WIDTH"
                                [attr.cx]="(SPACE_SIZE * x) + (SPACE_SIZE / 2)"
                                [attr.cy]="(SPACE_SIZE * y) + (SPACE_SIZE / 2)"
                                [ngClass]="getPieceClasses(x, y)"
                                class="base"/>
                    }
                </g>
            }
        </g>
    }
    @for (move of moves; track move.toString()) {
        <rect (click)="onClick(move.getSecond().x, move.getSecond().y)"
              [attr.transform]="getTranslationAt(move.getSecond())"
              [attr.x]="SPACE_SIZE / 3"
              [attr.y]="SPACE_SIZE / 3"
              [attr.width]="SPACE_SIZE / 3"
              [attr.height]="SPACE_SIZE / 3"
              [attr.fill]="move.isDuplication() ? 'green' : 'red'"/>
    }
</svg>
